import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";

export default function Splash() {
  const nav = useNavigate();
  const { t } = useI18n();
  const { tenant } = useAuth();
  useEffect(() => {
    const id = setTimeout(() => nav("/login"), 1800);
    return () => clearTimeout(id);
  }, [nav]);

  return (
    <div className="mobile-frame bg-tenant-gradient text-white min-h-screen flex flex-col items-center justify-center relative overflow-hidden" data-testid="splash-screen">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ backgroundImage: "radial-gradient(circle at 20% 10%, rgba(212,175,55,0.4), transparent 40%), radial-gradient(circle at 80% 90%, rgba(212,175,55,0.25), transparent 40%)" }} />
      <div className="relative z-10 flex flex-col items-center animate-[fadeUp_0.6s_ease-out]">
        <div className="w-28 h-28 rounded-[2rem] gold-grad grid place-items-center text-tenant-primary shadow-2xl mb-6 overflow-hidden">
          {tenant?.logo_url ? (
            <img src={tenant.logo_url} alt={tenant.brand_name} className="w-full h-full object-cover" />
          ) : (
            <ShieldCheck className="w-14 h-14" strokeWidth={2.2} />
          )}
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight text-center">
          {tenant?.brand_name || t("app_name")}
        </h1>
        <p className="text-tenant-accent text-sm uppercase tracking-[0.3em] mt-2 font-bold">
          {t("tagline")}
        </p>
        <div className="mt-12 flex items-center gap-2 text-xs opacity-70">
          <Sparkles className="w-3.5 h-3.5" />
          Trusted Financial Support Partner
        </div>
      </div>
    </div>
  );
}
